import { ControlPosition, MapControl } from '@vis.gl/react-google-maps'

// import type { AutocompleteMode } from './app'
import { AutoCompleteMap } from './AutoCompleteMap'

type CustomAutocompleteControlProps = {
	controlPosition: ControlPosition
	selectedAutocompleteMode: AutocompleteMode
	onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void
}

export type AutocompleteMode = { id: string; label: string }

export const CustomMapControl = ({
	controlPosition,
	selectedAutocompleteMode,
	onPlaceSelect,
}: CustomAutocompleteControlProps) => {
	const { id } = selectedAutocompleteMode

	return (
		<MapControl position={controlPosition}>
			<div className='autocomplete-control'>
				{id === 'classic' && <AutoCompleteMap onPlaceSelect={onPlaceSelect} />}
			</div>
		</MapControl>
	)
}
